import { EDocumentActionTypes } from '../../actions/document';
import { TReduxActions } from '../../types/redux';
import { ILegalDocument } from '../../types/document';

export function documentReducer(state: ILegalDocument | null = null, action: TReduxActions): ILegalDocument | null {
  if (action.type === EDocumentActionTypes.SetDocument) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
}
